import { withRouter, Link } from "react-router-dom"
import React, { useState } from "react"
import { Card, CardBody, Row, Col } from "reactstrap"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import BootstrapTable from "react-bootstrap-table-next"
import ReactHTMLTableToExcel from "react-html-table-to-excel"
import * as moment from "moment"
import TableLoader from "components/Common/TableLoader"

function Table(props) {
  const { data } = props

  // Calculate totals for each column
  const totals = data.reduce(
    (acc, row) => {
      acc.excise_tax += row.excise_tax || 0
      acc.unique_player_excise += row.unique_player_excise || 0
      acc.wht += row.wht || 0
      acc.unique_players_wht += row.unique_players_wht || 0
      acc.total_tax += row.total_tax || 0
      return acc
    },
    {
      excise_tax: 0,
      unique_player_excise: 0,
      wht: 0,
      unique_players_wht: 0,
      total_tax: 0,
    }
  )

  const columns = [
    {
      dataField: "day",
      text: "Day Of Month",
      sort: true,
      footer: "Total",
    },
    {
      dataField: "excise_tax",
      text: "Excise Tax",
      sort: true,
      formatter: (cell, row) => (
        <>{Number(row.excise_tax.toFixed(2)).toLocaleString("en-GB")}</>
      ),
      footer: () => (
        <>{Number(totals.excise_tax.toFixed(2)).toLocaleString("en-GB")}</>
      ),
    },
    {
      dataField: "unique_player_excise",
      text: "Unique Players Excise",
      sort: true,
      formatter: (cellContent, row) => (
        <>
          {parseFloat(
            Number(row.unique_player_excise).toFixed(0)
          ).toLocaleString("en-GB")}
        </>
      ),
      footer: () => (
        <>
          {Number(totals.unique_player_excise.toFixed(0)).toLocaleString(
            "en-GB"
          )}
        </>
      ),
    },
    {
      dataField: "wht",
      text: "WHT",
      sort: true,
      formatter: (cell, row) => (
        <>{Number(parseFloat(row.wht).toFixed(2)).toLocaleString("en-GB")}</>
      ),
      footer: () => (
        <>{Number(totals.wht.toFixed(2)).toLocaleString("en-GB")}</>
      ),
    },
    {
      dataField: "unique_players_wht",
      text: "UniquePlayersWHT",
      sort: true,
      formatter: (cell, row) => (
        <>{Number(row.unique_players_wht.toFixed(0)).toLocaleString("en-GB")}</>
      ),
      footer: () => (
        <>
          {Number(totals.unique_players_wht.toFixed(0)).toLocaleString("en-GB")}
        </>
      ),
    },
    {
      dataField: "total_tax",
      text: "Total Tax",
      sort: true,
      formatter: (cell, row) => (
        <>{Number(row.total_tax.toFixed(2)).toLocaleString("en-GB")}</>
      ),
      footer: () => (
        <>{Number(totals.total_tax.toFixed(2)).toLocaleString("en-GB")}</>
      ),
    },
  ]

  const defaultSorted = [
    {
      dataField: "orderId",
      order: "desc",
    },
  ]

  const { SearchBar } = Search
  //pagination customization

  const pageOptions = {
    sizePerPage: data.length,
    totalSize: data.length,
    custom: true,
  }

  return (
    <>
      <Card>
        <CardBody>
          <div className="mb-4 h4 card-title">{"Tax Report"}</div>
          {props.loadingMessage && props.loadingMessage == "1" ? (
            <TableLoader />
          ) : (
            <PaginationProvider
              pagination={paginationFactory(pageOptions)}
              keyField="id"
              columns={columns}
              data={data}
            >
              {({ paginationProps, paginationTableProps }) => (
                <ToolkitProvider
                  keyField="id"
                  data={data}
                  columns={columns}
                  bootstrap4
                  search
                >
                  {toolkitProps => (
                    <React.Fragment>
                      <Row className="mb-2">
                        <Col sm="6">
                          <Row>
                            <Col sm="6">
                              <div className="search-box me-2 mb-2 d-inline-block">
                                <div className="position-relative">
                                  <SearchBar {...toolkitProps.searchProps} />
                                  <i className="bx bx-search-alt search-icon" />
                                </div>
                              </div>
                            </Col>
                            <Col sm="6">
                              <div>
                                <ReactHTMLTableToExcel
                                  id="test-table-xls-button"
                                  className="download-table-xls-button w-md btn btn-primary"
                                  table="table-to-xls"
                                  filename={`Tax-Report-${moment(
                                    new Date()
                                  ).format("DD/MM/YYYY")}`}
                                  sheet="tablexls"
                                  buttonText="Download"
                                  type="button"
                                />
                              </div>
                            </Col>
                          </Row>
                        </Col>
                        <Col sm={6}></Col>
                      </Row>
                      <Row>
                        <Col xl="12">
                          <div className="table-responsive">
                            <BootstrapTable
                              id="table-to-xls"
                              keyField="id"
                              responsive
                              bordered={false}
                              striped={false}
                              defaultSorted={defaultSorted}
                              //   selectRow={selectRow}
                              classes={
                                "table align-middle table-nowrap table-check"
                              }
                              headerWrapperClasses={"table-light"}
                              {...toolkitProps.baseProps}
                              {...paginationTableProps}
                              rowClasses={"mytable-hover-row"}
                              footerClasses="footer-class"
                            />
                          </div>
                        </Col>
                      </Row>
                      <div className="pagination pagination-rounded justify-content-end">
                        <PaginationListStandalone {...paginationProps} />
                      </div>
                    </React.Fragment>
                  )}
                </ToolkitProvider>
              )}
            </PaginationProvider>
          )}
        </CardBody>
      </Card>
    </>
  )
}

export default Table
